import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  ApplicationState,
  CaseSettingsState,
  AppState,
  CaseSettingsActionCreators
} from '../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import {
  CardContent,
  Button,
  IconButton,
  DialogTitle,
  Grid,
  Typography,
  ButtonGroup,
  Tooltip,
  Box,
  Dialog,
  DialogContent,
  Modal,
  DialogActions,
  DialogContentText,
  TextField
} from '@material-ui/core';
import { AppContext, ApplicationContext } from '../../context/Contexts';
import { ITranslatorService } from '../../services/Interfaces/ITranslatorService';
import { RouteComponentProps } from 'react-router';
import { Card, CardFooter } from 'reactstrap';
import { ScaleLoader } from 'react-spinners';
import {
  WorkflowDocumentType,
  WorkflowFormAction,
  WorkflowSectionStep,
  WorkflowSectionStepForm
} from '../../interfaces/Workflow';
import { isNullOrUndefined } from 'util';
import {
  Appointment,
  AppointmentPaymentStatusRequest,
  CarfixAttachmentNotificationRequest,
  CarfixAttachmentNotificationResponse,
  CaseAttachment,
  CaseSelectedAttachment,
  ChangeCaseStatusBasedCodeRequest,
  AddInvoiceCaseAttachmentResponseDto,
  InvoicePaymentConfirmationRequest,
  InvoicePaymentConfirmationResponse,
  PaymentDto,
  PreAppointment,
  GetCaseAttachmentsRequestDto,
  GetCaseAttachmentsArchiveRequestDto,
  GetCaseAppointmentAttachmentsRequestDto,
  RepairServiceInvoiceContext
} from '../../interfaces/Case';
import { ICaseService } from '../../services/Interfaces/ICaseService';
import { IReferentialService } from '../../services/Interfaces/IReferentialService';
import Referentials from '../../helpers/Referentials.json';
import {
  AppointmentPaymentStatus,
  AttachmentTypeCode,
  CaseStatusCodeEnum,
  hideButtonsSectionSteps,
  CountryCodeEnum,
  ParametreCode,
  PaymentMethodCodeEnum,
  ProviderCategoryCodeEnum,
  ReferentialCode,
  UploadSizeLimit,
  WorflowEditableReport,
  WorkflowFormActionTypeCode
} from '../../helpers/Constants';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DescriptionIcon from '@material-ui/icons/Description';
import FileSaver from 'file-saver';
import { FormHelpers } from '../../helpers/forms/FormHelpers';
import { AppUser } from '../../interfaces/AppUser';
import CloseIcon from '@material-ui/icons/Close';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import FileViewer from 'react-file-viewer';
import { IReferential } from '../../interfaces/IReferential';
import GetAppIcon from '@material-ui/icons/GetApp';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import FileUploadRow from '../_shared/FileUploadRow';
import _, { at } from 'lodash';
import {
  OrganizationInfoDto,
  AddOrganizationProviderRequestDto,
  GetOrganizationProviderListRequestDto,
  OrganizationProvider
} from '../../interfaces/Organization';
import { createDefaultOrganizationProvider } from '../../utils/organization';
import { IOrganizationService } from '../../services/Interfaces/IOrganizationService';
import { IVehicleService } from '../../services/Interfaces/IVehicleService';
import { AddRepairMaintenanceCostRequestDto } from '../../interfaces/Vehicle';
import { workers } from 'cluster';
import Resizer from 'react-image-file-resizer';
import { GetInvoiceReportRequestDto, ReportParameter } from '../../interfaces/Reports';
import { IReportsService } from '../../services/Interfaces/IReportsService';
import renewLogo from '../../assets/images/renew.png';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import NumberFormat from 'react-number-format';
import { Utils } from '../../helpers/Utils';
import RepairServiceInvoiceModal from '../_shared/RepairServiceInvoiceModal';
import RepairServiceInvoiceView from '../_shared/RepairServiceInvoiceView';
import MuiTheme from '../../theme';

interface ICaseDetailsCaseTabDocumentsFormState {
  caseAttachments: CaseAttachment[];
  attachmentTypeList: WorkflowDocumentType[];
  isLoading: boolean;
  hasRights: boolean;
  executing: boolean;
  isDialogOpen: boolean;
  previewAttachFile: any;
  previewAttachFileExtension: string;
  isCameraDialogOpen: boolean;
  isSelection: boolean;
  attachmentTypeClicked: any;
  showUploadMessage: boolean;
  isOpen: boolean;
  dialogVisible: boolean;
  selectedAttachment: CaseSelectedAttachment;
  caseStatuses: IReferential[];
  wfTransitionStepAction: WorkflowFormAction | null;
  appointment: Appointment | null;
  appointmentPaymentStatus: PreAppointment | null;
  hideButton: boolean;
  lastCaseAppointment: Appointment | null;
  isPaymentConfigModalOpen: boolean;
  paymentMethods: IReferential[];
  currencies: IReferential[];
  organizationProvider: OrganizationProvider | null;
  isSavingPaymentConfig: boolean;
  isRepairServiceInvoiceModalOpen: boolean;
  repairServiceInvoiceContext: RepairServiceInvoiceContext | null;
  serviceOrganization: OrganizationInfoDto | null;
  invoiceServiceOrganization: OrganizationInfoDto | null;
}

export interface ExternalCaseDetailsCaseTabDocumentsFormProps {
  workflowForm: WorkflowSectionStepForm;
}

type ICaseDetailsCaseTabDocumentsFormProps = ExternalCaseDetailsCaseTabDocumentsFormProps & {
  caseSettingsState: CaseSettingsState;
  appState: AppState;
} & typeof CaseSettingsActionCreators &
  ProviderContext &
  RouteComponentProps<{ id: string }>;
export const imageExtensions = ['png', 'jpeg', 'jpg', 'bmp'];

class CaseDetailsCaseTabDocumentsForm extends React.PureComponent<
  ICaseDetailsCaseTabDocumentsFormProps,
  ICaseDetailsCaseTabDocumentsFormState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;
  private organizationService!: IOrganizationService;
  private reportsService!: IReportsService;
  private vehicleService!: IVehicleService;
  static contextType = ApplicationContext;
  private reportInProgress = false;
  state = {
    caseAttachments: [],
    attachmentTypeList: [],
    isLoading: false,
    hasRights: false,
    executing: false,
    isDialogOpen: false,
    previewAttachFile: '',
    previewAttachFileExtension: '',
    isCameraDialogOpen: false,
    isSelection: false,
    attachmentTypeClicked: null,
    showUploadMessage: false,
    isOpen: false,
    dialogVisible: false,
    selectedAttachment: {
      id: -1,
      fileName: ''
    },
    caseStatuses: [],
    wfTransitionStepAction: null,
    appointment: null,
    isPaymentConfigModalOpen: false,
    paymentMethods: [],
    currencies: [],
    organizationProvider: null,
    isSavingPaymentConfig: false,
    appointmentPaymentStatus: null,
    hideButton: false,
    lastCaseAppointment: null,
    isRepairServiceInvoiceModalOpen: false,
    repairServiceInvoiceContext: null,
    serviceOrganization: null,
    invoiceServiceOrganization: null
  } as ICaseDetailsCaseTabDocumentsFormState;

  public componentDidMount() {
    const caseSettings = this.props.caseSettingsState.caseSettings;
    const caseId = Number.parseInt(this.props.match.params.id);
    if (isNullOrUndefined(caseSettings) || Number.isNaN(caseId)) {
      return;
    }

    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadCaseDocumentsForm();
      }
    );
  }

  loadCaseDocumentsForm = async () => {
    const caseSettings = this.props.caseSettingsState.caseSettings;
    const caseId = Number.parseInt(this.props.match.params.id);
    if (isNullOrUndefined(caseSettings) || Number.isNaN(caseId)) {
      return;
    }

    const ref = Referentials.referential.find(
      (item) => item.code === ReferentialCode.AttachmentType
    );
    const refCaseStatus = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CaseStatus
    );
    const refAppointmentCategoryType = Referentials.referential.find(
      (item) => item.code === ReferentialCode.AppointmentCategoryType
    );
    const refPaymentMethod = Referentials.referential.find(
      (item) => item.code === ReferentialCode.PaymentMethod
    );
    const refProviderCategory = Referentials.referential.find(
      (item) => item.code === ReferentialCode.ProviderCategoryType
    );
    const refCurrency = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Currency
    );

    let workflowDocumentsTypes = this.props.workflowForm.workflowDocumentTypes;
    const [
      attachmentTypes,
      caseStatuses,
      appointment,
      appointmentCategoryTypes,
      paymentMethods,
      providerCategories,
      currencies
    ] = await Promise.all([
      this.appReferentialService.Get(ref!.baseUrl),
      this.appReferentialService.Get(refCaseStatus!.baseUrl),
      this.props.workflowForm.appointmentCategoryTypeId != null
        ? this.caseService.GetAppointmentByType(
            caseId,
            this.props.workflowForm.appointmentCategoryTypeId
          )
        : null,
      this.appReferentialService.Get(refAppointmentCategoryType!.baseUrl),
      this.appReferentialService.Get(refPaymentMethod!.baseUrl),
      this.appReferentialService.Get(refProviderCategory!.baseUrl),
      this.appReferentialService.Get(refCurrency!.baseUrl)
    ]);

    workflowDocumentsTypes.forEach((wfDoc) => {
      const documentType = attachmentTypes.find((item) => item.id === wfDoc.documentTypeId);
      wfDoc.documentType = isNullOrUndefined(documentType) ? null : documentType;
    });

    let appointmentPaymentStatus = null;
    let lastCaseAppointment = null;
    if (
      workflowDocumentsTypes.some(
        (item) => item.documentType!.code === AttachmentTypeCode.INVOICE_REPAIR
      )
    ) {
      const paymentRequest = {
        caseId: caseId,
        workflowId: this.props.caseSettingsState.caseSettings!.workflow.id
      } as AppointmentPaymentStatusRequest;
      appointmentPaymentStatus = await this.caseService.GetAppointmentPaymentStatus(paymentRequest);

      lastCaseAppointment = appointment ?? (await this.caseService.GetAppointmentByCaseId(caseId));
    }

    if (this.props.workflowForm!.appointmentCategoryTypeId) {
      const appointmentCategoryType = appointmentCategoryTypes.find(
        (item) => item.id === this.props.workflowForm!.appointmentCategoryTypeId
      );
      this.props.workflowForm.appointmentCategoryType = appointmentCategoryType || null;
    }

    const serviceId =
      this.props.caseSettingsState.case?.serviceId ?? this.props.appState.appUser!.organizationId!;
    const serviceOrganization =
      (await this.organizationService.GetOrganizationByIds({ organizationIds: [serviceId] }))[0] ??
      null;
    let invoiceServiceOrganization = serviceOrganization;
    if (serviceOrganization?.hoIdIssuesInvoice && serviceOrganization.hoId) {
      invoiceServiceOrganization =
        (
          await this.organizationService.GetOrganizationByIds({
            organizationIds: [serviceOrganization.hoId]
          })
        )[0] ?? null;
    }

    let attachmentTypeList = _.cloneDeep(this.props.workflowForm.workflowDocumentTypes);
    console.log(
      'isPrcIntegration',
      this.props.caseSettingsState.caseSettings!.workflow.isPrcIntegration
    );
    console.log(
      'hideOtherAttachments',
      this.props.appState.appUser!.organization!.organizationType!.hideOtherAttachments
    );

    if (
      this.props.caseSettingsState.caseSettings!.workflow.isPrcIntegration &&
      this.props.appState.appUser!.organization!.organizationType!.hideOtherAttachments
    ) {
      workflowDocumentsTypes = workflowDocumentsTypes.filter(
        (item) => item.documentType!.code != AttachmentTypeCode.OTHER
      );
    }

    let caseAttachments = appointment
      ? await this.caseService.GetCaseAppointmentAttachments({
          caseId: caseId,
          appointmentId: appointment.id,
          types: workflowDocumentsTypes.map((item) => item.documentType!.code!)
        } as GetCaseAppointmentAttachmentsRequestDto)
      : await this.caseService.GetCaseAttachments({
          caseId: caseId,
          types: workflowDocumentsTypes.map((item) => item.documentType!.code!),
          viewHiddenServiceDocuments:
            this.props.appState.appUser!.organization!.organizationType!
              .viewHiddenServiceDocuments ?? false
        } as GetCaseAttachmentsRequestDto);
    const step = this.getWorkflowSectionStep(this.props.workflowForm.workflowSectionStepId);
    console.log('step', step);
    console.log(
      'current',
      step &&
        step.isCurrent(
          this.props.caseSettingsState.case!.caseStatus.caseStatusId,
          this.props.appState.appUser!
        )
    );
    const organizationProvider = await this.loadOrganizationProvider(
      lastCaseAppointment,
      serviceOrganization,
      providerCategories,
      serviceId
    );
    if (organizationProvider) {
      organizationProvider.paymentMethod =
        paymentMethods.find((m) => m.id === organizationProvider.paymentMethodId) ?? null;
    }

    if (
      this.props.caseSettingsState.caseSettings!.workflow.isCarfixIntegration &&
      step &&
      step.isCurrent(
        this.props.caseSettingsState.case!.caseStatus.caseStatusId,
        this.props.appState.appUser!
      )
    ) {
      console.log('attachmentTypeList', attachmentTypeList);

      const relevantAttachmentTypes = [
        AttachmentTypeCode.WORK_ORDER.toString(),
        AttachmentTypeCode.HAND_OVER.toString(),
        AttachmentTypeCode.INVOICE_REPAIR.toString()
      ];

      const hasRelevantAttachment = attachmentTypeList.some((attach) =>
        relevantAttachmentTypes.includes(attach.documentType!.code || '')
      );

      if (hasRelevantAttachment) {
        const hasRelevantCaseAttachment = caseAttachments.some((attach) =>
          relevantAttachmentTypes.includes(attach.attachmentType!.code || '')
        );

        if (hasRelevantCaseAttachment) {
          console.log('The caseAttachments contains a relevant attachment.');
        } else {
          console.log('The caseAttachments does not contain any relevant attachments.');

          const workflowDocumentType = attachmentTypeList.find((attach) =>
            relevantAttachmentTypes.includes(attach.documentType!.code || '')
          );
          console.log('workflowDocumentType', workflowDocumentType);

          if (workflowDocumentType) {
            if (this.reportInProgress) {
              console.log('GenerateReport skip — already running');
            } else {
              this.reportInProgress = true;
              await this.generateReport(
                workflowDocumentType,
                appointment,
                appointmentPaymentStatus?.pre_appointment || null,
                organizationProvider
              );
              caseAttachments = appointment
                ? await this.caseService.GetCaseAppointmentAttachments({
                    caseId: caseId,
                    appointmentId: appointment.id,
                    types: workflowDocumentsTypes.map((item) => item.documentType!.code!)
                  } as GetCaseAppointmentAttachmentsRequestDto)
                : await this.caseService.GetCaseAttachments({
                    caseId: caseId,
                    types: workflowDocumentsTypes.map((item) => item.documentType!.code!),
                    viewHiddenServiceDocuments:
                      this.props.appState.appUser!.organization!.organizationType!
                        .viewHiddenServiceDocuments ?? false
                  } as GetCaseAttachmentsRequestDto);
              this.reportInProgress = false;
            }
          }
        }
      } else {
        console.log('The attachmentTypeList does not contain any relevant attachments.');
      }
    }

    const photosProm = [] as any[];
    caseAttachments.forEach((element) => {
      const categ = workflowDocumentsTypes.find(
        (wdt) => wdt.documentTypeId === element.attachmentTypeId
      );
      if (!categ!.isMultiple && categ!.isSelectionGroup) {
        photosProm.push(this.caseService.GetCaseAttachment(element.fileName));
      } else {
        photosProm.push(null);
      }
    });

    const photos = await Promise.all([...photosProm]);
    caseAttachments.forEach((elem, index) => {
      elem.file = photos[index];
    });

    const hasRights = FormHelpers.HasRights(
      this.props.workflowForm.workflowFormPermissions,
      this.props.appState.appUser!,
      this.props.appState,
      this.props.caseSettingsState.case!.caseStatus.caseStatusId
    );

    if (
      this.props.caseSettingsState.caseSettings!.workflow.isPrcIntegration &&
      this.props.appState.appUser!.organization!.organizationType!.hideOtherAttachments
    ) {
      attachmentTypeList = attachmentTypeList.filter(
        (item) => item.documentType!.code != AttachmentTypeCode.OTHER
      );
    }
    attachmentTypeList.forEach((attachmentType) => {
      attachmentType.isLoading = false;
    });

    const wfStepActions = this.props.workflowForm.workflowFormActions;
    const wfTransitionStepAction =
      wfStepActions.find(
        (item) =>
          item.actionType?.code === WorkflowFormActionTypeCode.STATUS_TRANSITION &&
          this.props.caseSettingsState.case!.caseStatus.caseStatusId === item.fromStatusId
      ) || null;

    const invoiceAttachments = caseAttachments.filter(
      (attach) =>
        attach.attachmentType?.code ===
          AttachmentTypeCode.REPAIR_SERVICE_INVOICE_TO_GTM.toString() && attach.invoiceId
    );
    const invoices = await Promise.all(
      invoiceAttachments.map((attach) => this.caseService.GetInvoiceById(attach.invoiceId!))
    );
    invoiceAttachments.forEach((attach) => {
      attach.invoice = invoices.find((invoice) => invoice?.id === attach.invoiceId) ?? null;
    });

    console.log('appointment', appointment, 'appointmentPaymentStatus', appointmentPaymentStatus);
    this.setState({
      caseAttachments: caseAttachments.sort(function (a: any, b: any) {
        return b.uploadDate - a.uploadDate;
      }),
      attachmentTypeList: attachmentTypeList,
      isLoading: false,
      hasRights: hasRights,
      showUploadMessage: this.props.appState.appUser!.organization!.uploadFeature,
      caseStatuses: caseStatuses,
      wfTransitionStepAction: wfTransitionStepAction,
      appointment: appointment,
      appointmentPaymentStatus: appointmentPaymentStatus?.pre_appointment || null,
      hideButton: hideButtonsSectionSteps.includes(step?.workflowStep?.code ?? ''),
      lastCaseAppointment: lastCaseAppointment,
      paymentMethods: paymentMethods,
      currencies: currencies,
      organizationProvider: organizationProvider,
      serviceOrganization: serviceOrganization,
      invoiceServiceOrganization: invoiceServiceOrganization
    });
  };

  loadOrganizationProvider = async (
    lastCaseAppointment: Appointment | null,
    org: OrganizationInfoDto | null,
    providerCategories: IReferential[],
    orgId: number | null
  ): Promise<OrganizationProvider | null> => {
    if (lastCaseAppointment?.partnerOrganizationId == null) {
      return null;
    }

    const providerCategory = providerCategories.find(
      (c) => c.code === ProviderCategoryCodeEnum.PARTENER_FLOTA
    );

    if (!providerCategory) {
      return null;
    }

    const providers = await this.organizationService.GetOrganizationProviders({
      organizationId: orgId,
      providerCategoryId: providerCategory.id,
      partnerId: lastCaseAppointment.partnerOrganizationId
    } as GetOrganizationProviderListRequestDto);

    const matched = providers.length > 0 ? providers[0] : null;
    if (matched) {
      return matched;
    }

    return createDefaultOrganizationProvider(
      orgId,
      providerCategory.id,
      org?.paymentMethodId ?? 1,
      org?.paymentDays ?? 0,
      lastCaseAppointment.partnerOrganizationId
    );
  };

  getWorkflowSectionStep = (workflowSectionStepId: number): WorkflowSectionStep | null => {
    const sections = this.props.caseSettingsState.caseSettings!.workflow.workflowSections!;
    for (const section of sections) {
      for (const step of section.workflowSectionSteps) {
        if (step.id == workflowSectionStepId) {
          return step;
        }
      }
    }
    return null;
  };

  setCameraDetails = async (attachmentType: WorkflowDocumentType) => {
    this.setState({
      attachmentTypeClicked: attachmentType.documentType!,
      isCameraDialogOpen: true,
      isSelection: attachmentType.isSelectionGroup
    });
  };

  setAttachmentTypeList = (workflowDocumentType: WorkflowDocumentType, value: boolean) => {
    const attachmentTypeList = _.cloneDeep(this.state.attachmentTypeList);
    for (let i = 0; i < attachmentTypeList.length; i++) {
      if (attachmentTypeList[i].id === workflowDocumentType.id) {
        attachmentTypeList[i].isLoading = value;
      }
    }

    return attachmentTypeList;
  };

  /**
   * Get dimensions of any image by url
   * @param {string} url
   * @param {number} [rejectTimeout] timeout for reject
   * @return {Promise<{ width: number, height: number }>}
   */
  reactImageSize = (
    url: string,
    rejectTimeout: number
  ): Promise<{ width: number; height: number }> =>
    new Promise((resolve, reject) => {
      let timer: NodeJS.Timeout | null = null;

      const img = new Image();

      img.addEventListener('load', () => {
        if (timer) {
          clearTimeout(timer);
        }

        resolve({ width: img.width, height: img.height });
      });

      img.addEventListener('error', (event) => {
        if (timer) {
          clearTimeout(timer);
        }

        reject(`${event.type}: ${event.message}`);
      });

      img.src = url;

      if (rejectTimeout) {
        timer = setTimeout(() => reject('Timeout exception'), rejectTimeout);
      }
    });

  resizeImageFile = (file: any): Promise<File> =>
    new Promise((resolve, reject) => {
      try {
        //The Pixels value For 5 Megabytes at 4:3 Respect Ratio and 24 Bit depth is:
        //1526 X 1145
        Resizer.imageFileResizer(
          file,
          1526,
          1145,
          'jpg',
          100,
          0,
          (uri) => {
            resolve(uri as File);
          },
          'file',
          600,
          800
        );
      } catch (err) {
        console.log(err);
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
        reject();
      }
    });

  modifySelectionImage = async (file: File, dealerName: string, city: string): Promise<File> => {
    console.log('Dealer Name: ', dealerName, 'City: ', city);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const scaledWidth = 800;
          const blackBarHeight = 75;
          const scaleFactor = scaledWidth / img.width;
          const scaledHeight = img.height * scaleFactor;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) return reject('Context nul');

          canvas.width = scaledWidth;
          canvas.height = scaledHeight + blackBarHeight * 2;

          // Fundal negru sus
          ctx.fillStyle = 'black';
          ctx.fillRect(0, 0, scaledWidth, blackBarHeight);

          // Imagine în centru
          ctx.drawImage(img, 0, blackBarHeight, scaledWidth, scaledHeight);

          // Fundal negru jos
          ctx.fillStyle = 'black';
          ctx.fillRect(0, scaledHeight + blackBarHeight, scaledWidth, blackBarHeight);

          const logo = new Image();
          logo.src = renewLogo;

          logo.onload = () => {
            const logoWidth = logo.width;
            const logoHeight = logo.height;
            const logoX = 25;
            const logoY = (blackBarHeight - logoHeight) / 2;

            // Logo
            ctx.drawImage(logo, logoX, logoY, logoWidth, logoHeight);

            // Text lângă logo
            ctx.fillStyle = 'white';
            ctx.font = '22px NouvelR, sans-serif';
            const textLines = [
              'vehicule de ocazie verificate, realiniate si certificate',
              'electrice, hybride, diesel, benzina si GPL'
            ];
            const textX = logoX + logoWidth + 17;
            const textY = logoY + 17;
            textLines.forEach((line, index) => {
              ctx.fillText(line, textX, textY + index * 25);
            });

            // Textul dealerului (jos dreapta)
            ctx.fillStyle = 'white';
            ctx.font = '700 36px NouvelR, sans-serif';
            ctx.textAlign = 'right';
            ctx.textBaseline = 'middle';
            const dealerX = scaledWidth - 25;
            const dealerY = scaledHeight + blackBarHeight + blackBarHeight / 2 - (city ? 10 : 0);
            ctx.fillText(dealerName, dealerX, dealerY);

            if (city) {
              ctx.font = '500 18px NouvelR, sans-serif';
              ctx.fillText(city, dealerX, dealerY + 25);
            }

            // Convertim în fișier final
            const outputType = file.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
            const outputQuality = outputType === 'image/jpeg' ? 0.8 : 1.0;

            canvas.toBlob(
              (blob) => {
                if (!blob) return reject('Eroare la blob');
                const ext = outputType === 'image/jpeg' ? '.jpg' : '.png';
                const newFile = new File([blob], file.name.replace(/\.\w+$/, ext), {
                  type: outputType
                });
                resolve(newFile);
              },
              outputType,
              outputQuality
            );
          };

          logo.onerror = (err) => {
            console.error('Eroare la încărcarea logo-ului', err);
            reject(err);
          };
        };

        img.onerror = (err) => {
          console.error('Eroare la încărcarea imaginii', err);
          reject(err);
        };
      };

      reader.onerror = (err) => {
        console.error('Eroare la citirea fișierului', err);
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  modifyImage = async (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          const scaledWidth = 800;
          const scaleFactor = scaledWidth / img.width;
          const scaledHeight = img.height * scaleFactor;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) return;

          canvas.width = scaledWidth;
          canvas.height = scaledHeight;

          // Desenăm imaginea redimensionată
          ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight);

          // Generare fișier final
          const outputType = file.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
          const outputQuality = outputType === 'image/jpeg' ? 0.8 : 1.0;

          canvas.toBlob(
            (blob) => {
              const ext = outputType === 'image/jpeg' ? '.jpg' : '.png';
              const newFile = new File([blob!], file.name.replace(/\.\w+$/, ext), {
                type: outputType
              });
              resolve(newFile);
            },
            outputType,
            outputQuality
          );
        };

        img.onerror = (err) => {
          console.error('Eroare la încărcarea imaginii', err);
          reject(err);
        };
      };

      reader.onerror = (err) => {
        console.error('Eroare la citirea fișierului', err);
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  handleUploadAttachment = async (
    e: React.ChangeEvent<HTMLInputElement>,
    workflowDocumentType: WorkflowDocumentType
  ) => {
    try {
      if (e.target.files === null) {
        return;
      }
      e.persist();
      if (this.state.showUploadMessage) {
        if (e.target.files.length > 80 && workflowDocumentType.isMultiple) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MORE_PHOTOS', 'Limita de 80 de poze a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          e.target.value = '';
          return;
        }
      }
      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, true)
      });

      const unacceptedFileList: string[] = [];
      const attachments: CaseAttachment[] = [];
      const unacceptedCertificateFileList: string[] = [];
      for (let i = 0; i < e.target.files.length; i++) {
        let file = e.target.files![i];
        const ext = file.name.toLowerCase().split('.').pop();

        if (workflowDocumentType.allowOnlyImages) {
          if (!ext || !imageExtensions.includes(ext)) {
            unacceptedFileList.push(file.name);
            continue;
          }
        }

        //pentru selection grup
        if (workflowDocumentType.isSelectionGroup) {
          if (
            workflowDocumentType.documentType?.code ==
            AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
          ) {
            if (ext !== 'pdf') {
              unacceptedCertificateFileList.push(file.name);
              continue;
            }
          } else {
            if (ext && imageExtensions.includes(ext)) {
              if (workflowDocumentType.addWatermark) {
                const organizationName = this.props.appState.appUser?.organization?.name ?? '';
                const city = this.props.appState.appUser?.organization?.cityInfo?.displayName ?? '';
                const newSelectionImage = await this.modifySelectionImage(
                  file,
                  organizationName.toUpperCase(),
                  city
                );
                console.log('newSelectionImage', newSelectionImage);
                file = newSelectionImage;
              } else {
                file = await this.modifyImage(file);
              }
            } else {
              if (!workflowDocumentType.allowOnlyImages) {
                unacceptedFileList.push(file.name);
                continue;
              }
            }
          }
        }

        attachments.push({
          id: 0,
          caseId: this.props.caseSettingsState.case!.id,
          attachmentTypeId: workflowDocumentType.documentTypeId,
          attachmentType: workflowDocumentType.documentType,
          file: file,
          isSelection: workflowDocumentType.isSelectionGroup
        } as CaseAttachment);
      }

      if (unacceptedFileList.length) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'RENAULT_ACCEPTED_FORMAT',
            'Tipul fisierului acceptat este png, jpeg, jpg, bmp!'
          ) +
            ' \n' +
            this.translatorService.Tranlate(
              'RENAULT_ACCEPTED_FORMAT_MESSAGE',
              'Urmatoarele fisiere nu indeplinesc acesta conditie: '
            ) +
            ' \n' +
            unacceptedFileList.join(', '),
          {
            variant: 'warning',
            style: { whiteSpace: 'pre-line' }
          }
        );
        e.target.value = '';

        this.setState({
          attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
        });
        return;
      }

      if (unacceptedCertificateFileList.length) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'RENAULT_CERTIFICATE_VALIDATION_MESSAGE',
            'Tipul fisierului acceptat este PDF!'
          ) +
            ' \n' +
            this.translatorService.Tranlate(
              'RENAULT_ACCEPTED_FORMAT_MESSAGE',
              'Urmatoarele fisiere nu indeplinesc acesta conditie: '
            ) +
            ' \n' +
            unacceptedCertificateFileList.join(', '),
          {
            variant: 'warning',
            style: { whiteSpace: 'pre-line' }
          }
        );
        e.target.value = '';

        this.setState({
          attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
        });
        return;
      }

      const size = _.sumBy(attachments, 'file.size');
      console.log('Dimensiune bytes', size);

      if (this.state.showUploadMessage) {
        if (size > UploadSizeLimit.SizeLimit) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MAX_SIZE_PHOTOS', 'Limita de 500 MB a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          e.target.value = '';

          this.setState({
            attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
          });
          return;
        }
      }

      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, true)
      });

      const newFiles = await this.caseService.AddCaseAttachment(attachments);

      newFiles.forEach((item, index) => {
        item.file = attachments[index].file;
      });

      const caseAttachments = [...this.state.caseAttachments];
      caseAttachments.push(...newFiles);

      this.setState({
        caseAttachments: caseAttachments,
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
      e.target.value = '';
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      e.target.value = '';
    }
  };

  handleUploadAttachmentFromCamera = async (files: any, attachmentType: IReferential) => {
    try {
      if (files === null) {
        return;
      }
      if (this.state.showUploadMessage) {
        if (files.length > 80) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MORE_PHOTOS', 'Limita de 80 de poze a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          return;
        }
      }

      const attachments: CaseAttachment[] = [];
      for (let i = 0; i < files.length; i++) {
        attachments.push({
          id: 0,
          caseId: this.props.caseSettingsState.case!.id,
          attachmentTypeId: attachmentType.id,
          attachmentType: attachmentType,
          file: files![i],
          isSelection: this.state.isSelection
        } as CaseAttachment);
      }

      if (this.state.showUploadMessage) {
        const size = _.sumBy(attachments, 'file.size');
        if (size > UploadSizeLimit.SizeLimit) {
          this.props.enqueueSnackbar(
            this.translatorService.Tranlate('MAX_SIZE_PHOTOS', 'Limita de 500 MB a fost depasita!'),
            {
              variant: 'warning'
            }
          );
          return;
        }
      }

      const newFiles = await this.caseService.AddCaseAttachment(attachments);
      newFiles.forEach((item, index) => {
        item.file = attachments[index].file;
      });

      const caseAttachments = [...this.state.caseAttachments];
      caseAttachments.push(...newFiles);

      this.setState({
        caseAttachments: caseAttachments
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handleCloseConfirmationDialog = () => {
    this.setState({
      isOpen: false,
      dialogVisible: false
    });
  };

  handleOpenConfirmationDialog = () => {
    this.setState({
      isOpen: true,
      dialogVisible: true
    });
  };

  handleCloseModal = () => {
    this.setState({
      isOpen: false,
      dialogVisible: false
    });
  };

  openDeleteAttachmentPopUp = (id: number, fileName: string, fileInputKey?: number) => {
    this.setState({
      isOpen: true,
      dialogVisible: true,
      selectedAttachment: {
        id: id,
        fileName: fileName,
        fileInputKey: fileInputKey
      }
    });
  };

  handleDeleteAttachment = async (id: number, fileName: string, fileInputKey?: number) => {
    try {
      this.setState({ isOpen: false, dialogVisible: false });
      await this.caseService.RemoveCaseAttachment(fileName);

      const caseAttachments = [...this.state.caseAttachments];
      const index = caseAttachments.findIndex((item) => item.id === id);
      caseAttachments.splice(index, 1);

      this.setState({
        caseAttachments: caseAttachments,
        attachmentTypeList: this.state.attachmentTypeList.map((item) => {
          if (item.fileInputKey === fileInputKey) {
            return { ...item, fileInputKey: Date.now() };
          }
          return item;
        })
      });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  handlePreviewAttachment = async (originalFileName: string, filename: string) => {
    try {
      const fileBlob = await this.caseService.GetCaseAttachment(filename);
      const url = URL.createObjectURL(fileBlob);
      const extension = originalFileName.split('.').pop();

      if (isNullOrUndefined(extension)) {
        return;
      }

      this.setState({
        previewAttachFile: url,
        previewAttachFileExtension: extension!.toLowerCase(),
        isDialogOpen: true
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderPreviewAttachment = () => {
    return (
      <FileViewer
        fileType={this.state.previewAttachFileExtension}
        filePath={this.state.previewAttachFile}
      />
    );
  };

  renderPreviewImage = (file: any, fileName: string) => {
    const url = URL.createObjectURL(file);

    return <img src={url} alt={fileName} className="img-fluid" />;
  };

  renderAttachments = (workflowDocument: WorkflowDocumentType) => {
    const attachments = this.state.caseAttachments.filter(
      (item) => item.attachmentTypeId === workflowDocument.documentTypeId
    );
    const attachmentsToRender = [] as any[];

    attachments.forEach((attach, index) => {
      attachmentsToRender.push(
        <React.Fragment key={index}>
          <Grid container spacing={0}>
            <Grid item xs={1}>
              <div className="d-flex align-items-center">
                <IconButton
                  aria-label="preview"
                  color="inherit"
                  className="text-primary"
                  size="small"
                  onClick={(e) =>
                    this.handlePreviewAttachment(attach.originalFileName, attach.fileName)
                  }
                >
                  <VisibilityIcon />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={9}>
              <div className="align-box-row text-wrap " style={{ wordBreak: 'break-all' }}>
                <small>
                  <Button
                    color="primary"
                    className="m-2 text-primary"
                    onClick={(e) => this.downloadFile(attach.fileName, attach.originalFileName)}
                  >
                    <span>{attach.originalFileName}</span>
                  </Button>{' '}
                </small>
              </div>
            </Grid>

            <Grid item xs={2}>
              <div className="d-flex align-items-center">
                <IconButton
                  aria-label="download"
                  color="inherit"
                  size="small"
                  onClick={(e) => this.downloadFile(attach.fileName, attach.originalFileName)}
                >
                  <GetAppIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  hidden={!this.state.hasRights}
                  className="text-danger"
                  size="small"
                  onClick={(e) =>
                    this.openDeleteAttachmentPopUp(
                      attach.id,
                      attach.fileName,
                      workflowDocument.fileInputKey
                    )
                  }
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={0}>
            <Grid item xs={12}>
              {workflowDocument.isMultiple === false && workflowDocument.isSelectionGroup ? (
                <div style={{ flexBasis: '100%' }}>
                  <div className="d-flex align-items-center w-100 h-100">
                    {workflowDocument.documentType?.code ==
                    AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
                      ? ''
                      : this.renderPreviewImage(attach.file, attach.fileName)}
                  </div>
                </div>
              ) : (
                ''
              )}
            </Grid>
          </Grid>

          {workflowDocument.documentType?.code ===
            AttachmentTypeCode.REPAIR_SERVICE_INVOICE_TO_GTM.toString() && attach.invoice ? (
            <div style={{ whiteSpace: 'normal' }}>
              <Grid container spacing={0}>
                <RepairServiceInvoiceView invoice={attach.invoice} />
              </Grid>
            </div>
          ) : null}
        </React.Fragment>
      );
    });
    return attachmentsToRender;
  };

  downloadFile = async (fileName: string, origFileName: string) => {
    const fileBlob = await this.caseService.GetCaseAttachment(fileName);
    FileSaver.saveAs(fileBlob, origFileName);
  };

  canUpload = (attachemntType: WorkflowDocumentType): boolean => {
    const files = this.state.caseAttachments.filter(
      (attach) => attach.attachmentTypeId === attachemntType.documentTypeId
    );

    if (!attachemntType.isMultiple && files.length >= 1) {
      return false;
    }

    return true;
  };

  generateReport = async (
    workflowDocumentType: WorkflowDocumentType,
    appointment: Appointment | null,
    appointmentPaymentStatus: PreAppointment | null,
    organizationProvider: OrganizationProvider | null
  ) => {
    if (workflowDocumentType.documentType!.code === AttachmentTypeCode.INVOICE_REPAIR.toString()) {
      await this.generateInvoiceReport(
        workflowDocumentType,
        appointmentPaymentStatus,
        organizationProvider
      );
    } else {
      if (appointment === null) {
        return;
      }
      await this.generateInOutReport(workflowDocumentType, appointment);
    }
  };

  generateInOutReport = async (
    workflowDocumentType: WorkflowDocumentType,
    appointment: Appointment
  ) => {
    try {
      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, true)
      });
      //Get the In/Out Report
      const reportParameters = [
        {
          name: 'caseId',
          value: this.props.caseSettingsState.case!.id.toString()
        } as ReportParameter,
        {
          name: 'appointmentId',
          value: appointment.id.toString()
        },
        {
          name: 'organizationId',
          value:
            this.props.caseSettingsState.case?.serviceId ??
            this.props.appState.appUser!.organization?.id.toString()
        } as ReportParameter,
        {
          name: 'type',
          value: workflowDocumentType.documentType!.code!
        } as ReportParameter
      ];

      const fileBlob = await this.reportsService.GetInOutReport(
        workflowDocumentType.documentType!.code!,
        this.props.caseSettingsState.case!.id,
        appointment.id,
        reportParameters
      );

      //Save the IN/OUT Report into attachments
      const attachments: CaseAttachment[] = [];
      attachments.push({
        id: 0,
        caseId: this.props.caseSettingsState.case!.id,
        attachmentTypeId: workflowDocumentType.documentType!.id,
        attachmentType: workflowDocumentType.documentType!,
        file: new File(
          [fileBlob],
          workflowDocumentType.documentType!.displayName! +
            '-' +
            this.props.workflowForm.appointmentCategoryType!.displayName! +
            '.pdf',
          { type: 'application/pdf' }
        ),
        isSelection: false,
        appointmentId: appointment.id,
        includeInOtherTab: true
      } as CaseAttachment);

      console.log(attachments);
      const newFiles = await this.caseService.AddCaseAttachment(attachments);

      newFiles.forEach((item, index) => {
        item.file = attachments[index].file;
      });

      const caseAttachments = [...this.state.caseAttachments];
      caseAttachments.push(...newFiles);

      this.setState({
        caseAttachments: caseAttachments,
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
      });
    } catch (error) {
      console.log('error', error);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  generateInvoiceReport = async (
    workflowDocumentType: WorkflowDocumentType,
    appointmentPaymentStatus: PreAppointment | null,
    organizationProvider: OrganizationProvider | null
  ) => {
    try {
      this.setState({
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, true)
      });
      //Get the invoice Data
      const reportParameters = [
        {
          name: 'caseId',
          value: this.props.caseSettingsState.case!.id.toString()
        } as ReportParameter,
        {
          name: 'organizationId',
          value:
            this.props.caseSettingsState.case?.serviceId ??
            this.props.appState.appUser!.organization?.id.toString()
        } as ReportParameter
      ];

      const paidAmount = appointmentPaymentStatus?.payment?.amount ?? 0;
      if (
        appointmentPaymentStatus &&
        appointmentPaymentStatus?.payment?.status === AppointmentPaymentStatus.COMPLETED.toString()
      ) {
        reportParameters.push({
          name: 'paymentAmount',
          value: paidAmount.toString()
        } as ReportParameter);
      }

      const invoiceReportRequest: GetInvoiceReportRequestDto = {
        parameters: reportParameters,
        paymentMethodId: organizationProvider?.paymentMethodId ?? 1,
        paymentDays: organizationProvider?.paymentDays ?? 0
      };

      const response = await this.reportsService.GetInvoiceReport(
        workflowDocumentType.documentType!.code!,
        this.props.caseSettingsState.case!.id,
        invoiceReportRequest
      );

      const newFiles = (response.caseAttachments ?? []) as CaseAttachment[];

      const caseAttachments = [...this.state.caseAttachments];
      caseAttachments.push(...newFiles);

      this.setState({
        caseAttachments: caseAttachments,
        attachmentTypeList: this.setAttachmentTypeList(workflowDocumentType, false)
      });
    } catch (error) {
      console.log('error', error);
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderWorkflowAttachmentTypes = () => {
    const attachmentTypes = [] as any[];
    const attachmentTypeList = this.state.attachmentTypeList;
    if (attachmentTypeList.length !== 0) {
      attachmentTypeList.forEach((attach, index) => {
        attach.fileInputKey = Date.now();
        attachmentTypes.push(
          <div
            key={index}
            className={`p-1 d-flex justify-content-center ${
              attachmentTypeList.length === 1 ? 'w-80' : 'w-50'
            }`}
          >
            <Card className="card-box w-100 shadow-none">
              <div className="card-header">
                <div className="card-header--title">
                  <b>{attach.isSelectionGroup ? 'Renew: ' : ''}</b>
                  <b>
                    {attach.documentType!.displayName}
                    {attach.isMultiple ? (
                      <IconButton
                        aria-label="download"
                        color="inherit"
                        size="small"
                        disabled={
                          this.state.caseAttachments.filter(
                            (item) => item.attachmentTypeId === attach.documentTypeId
                          ).length === 0
                        }
                        onClick={(e) => {
                          this.downloadBasedOnAttachmentType(attach);
                        }}
                      >
                        <GetAppIcon />
                      </IconButton>
                    ) : (
                      ''
                    )}
                  </b>
                  {attach.downloadModelFile && (
                    <b>
                      {this.translatorService.Tranlate('DOWNLOAD_MODEL_FILE', 'Descarca model')}
                      <IconButton
                        aria-label="download"
                        color="inherit"
                        size="small"
                        onClick={(e) => {
                          this.downloadReport(attach);
                        }}
                      >
                        <GetAppIcon />
                      </IconButton>
                    </b>
                  )}
                </div>
              </div>

              <CardContent className="p-3 flex-grow-1">
                <div className="d-flex flex-row text-center flex-wrap justify-content-center">
                  <ScaleLoader color={'var(--primary)'} loading={attach.isLoading} />
                </div>
                {!attach.isLoading ? (
                  <div className="file-manager-wrapper h-100">
                    {this.state.caseAttachments.filter(
                      (item) => item.attachmentTypeId === attach.documentTypeId
                    ).length !== 0 ? (
                      <div className="table-responsive">
                        <table className="table table-striped table-hover text-nowrap mb-0">
                          <tbody>
                            <tr>
                              <td>{this.renderAttachments(attach)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="h-100 align-self-center text-center">
                        <DescriptionIcon
                          className="h-100"
                          color="secondary"
                          fontSize="large"
                        ></DescriptionIcon>
                      </div>
                    )}
                  </div>
                ) : (
                  ''
                )}
              </CardContent>
              <CardFooter className="p-3 border-0">
                {this.renderAttachmentCardFooter(attach)}
              </CardFooter>
            </Card>
          </div>
        );
      });
    }
    return attachmentTypes;
  };

  downloadAll = async () => {
    const fileBlob = await this.caseService.GetCaseAttachmentsArchive({
      caseId: this.props.caseSettingsState.case!.id,
      types: this.state.attachmentTypeList.map((item) => item.documentType!.code!),
      formId: null,
      viewHiddenServiceDocuments:
        this.props.appState.appUser!.organization!.organizationType!.viewHiddenServiceDocuments ??
        false
    } as GetCaseAttachmentsArchiveRequestDto);
    FileSaver.saveAs(
      fileBlob,
      this.props.caseSettingsState.case!.id + '_' + this.props.workflowForm.displayName + '.zip'
    );
  };

  downloadBasedOnAttachmentType = async (item: WorkflowDocumentType) => {
    this.setState({
      attachmentTypeList: this.setAttachmentTypeList(item, true)
    });
    const fileBlob = await this.caseService.GetCaseAttachmentsArchive({
      caseId: this.props.caseSettingsState.case!.id,
      types: [item.documentType!.code!],
      formId: null,
      viewHiddenServiceDocuments:
        this.props.appState.appUser!.organization!.organizationType!.viewHiddenServiceDocuments ??
        false
    } as GetCaseAttachmentsArchiveRequestDto);
    this.setState({
      attachmentTypeList: this.setAttachmentTypeList(item, false)
    });
    FileSaver.saveAs(
      fileBlob,
      this.props.caseSettingsState.case!.id + '_' + item.documentType!.displayName + '.zip'
    );
  };

  downloadReport = async (item: WorkflowDocumentType) => {
    this.setState({
      attachmentTypeList: this.setAttachmentTypeList(item, true)
    });
    const fileBlob = await this.reportsService.GetReport(item.documentType!.code!, []);

    this.setState({
      attachmentTypeList: this.setAttachmentTypeList(item, false)
    });

    FileSaver.saveAs(fileBlob, item.documentType!.displayName + '.pdf');
  };

  handleConfirmChanges = async () => {
    try {
      let error = false;
      this.state.attachmentTypeList.forEach((item) => {
        if (
          (item.isMandatory as unknown as boolean) === true &&
          this.state.caseAttachments.filter(
            (attach) => attach.attachmentTypeId === item.documentTypeId
          ).length === 0
        ) {
          this.props.enqueueSnackbar(
            item.documentType!.displayName +
              ' ' +
              this.translatorService.Tranlate(
                'CASE_DOCUMENTS_FORM_IS_MANDATORY',
                'este obligatoriu de adaugat!'
              ),
            { variant: 'error' }
          );
          error = true;
        }
        return;
      });

      this.setState({ executing: true });
      if (error === false) {
        if (this.props.workflowForm.form.hasActions) {
          await this.submitForm(
            this.props.caseSettingsState.case!.id,
            this.props.workflowForm.id,
            null
          );
        }

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      }
    } catch (ex: any) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          ex?.response?.data ?? 'Eroare incarcare documente!',
          'Eroare incarcare documente!'
        ),
        { variant: 'error' }
      );
    } finally {
      this.setState({ executing: false });
    }
  };

  carfixAttachmentNotification = async (
    attachmentType: IReferential | null,
    attachmentId: number
  ) => {
    try {
      const request = {
        caseId: this.props.caseSettingsState.case!.id,
        workflowId: this.props.caseSettingsState.caseSettings!.workflow.id,
        attachmentId: attachmentId,
        attachmentTypeCode: attachmentType!.code!
      } as CarfixAttachmentNotificationRequest;
      const result = (await this.caseService.CarfixAttachmentNotification(
        request
      )) as CarfixAttachmentNotificationResponse;
      if (!result.success) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate(result.code, result.message), {
          variant: 'error'
        });
        return true;
      }
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      return true;
    }
  };

  submitForm = async (caseId: number, caseSectionStepFormId: number, appUser: AppUser | null) => {
    let newStatus = await this.caseService.SubmitForm(caseId, caseSectionStepFormId, appUser);

    if (newStatus === null) {
      newStatus = this.props.caseSettingsState.case!.caseStatus;
    }
    this.props.SetCaseStatus(newStatus);

    if (this.props.caseSettingsState.caseSettings!.workflow.isCarfixIntegration) {
      const attachment =
        this.state.caseAttachments.length > 0 ? this.state.caseAttachments[0] : null;
      if (attachment === null) {
        return;
      }
      const attachmentType = this.state.attachmentTypeList.find(
        (item) => item.documentTypeId === attachment.attachmentTypeId
      );

      const hasError = await this.carfixAttachmentNotification(
        attachmentType!.documentType,
        attachment.id
      );
      if (hasError) {
        return;
      }
    }

    if (appUser !== null) {
      this.props.AddPartner(appUser!.hoId === null ? appUser!.organizationId : appUser!.hoId);
    }

    if (
      this.state.organizationProvider?.paymentMethod?.code === PaymentMethodCodeEnum.BANK_TRANSFER
    ) {
      await this.handleBankTransferInvoiceActions();
    }

    const hasRights = FormHelpers.HasRights(
      this.props.workflowForm.workflowFormPermissions,
      this.props.appState.appUser!,
      this.props.appState,
      newStatus.caseStatusId
    );
    this.setState({ hasRights: hasRights });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false
    });
  };

  closeCameraDialog = async () => {
    this.setState({
      isCameraDialogOpen: false,
      isSelection: false
    });
  };

  handleTakePhoto = async (dataUri: any) => {
    const arr = dataUri.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    let i = n;

    while (i--) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    const files = [
      new File([u8arr], 'captured_image_' + Math.random().toString(36).slice(2) + '.png', {
        type: mime
      })
    ];
    this.handleUploadAttachmentFromCamera(files, this.state.attachmentTypeClicked);
  };

  hasIntegrationDocuments = () => {
    return this.state.attachmentTypeList.some(
      (item) =>
        item.documentType!.code === AttachmentTypeCode.INVOICE_REPAIR.toString() ||
        item.documentType!.code === AttachmentTypeCode.HAND_OVER.toString() ||
        item.documentType!.code === AttachmentTypeCode.WORK_ORDER.toString()
    );
  };

  canEditPaymentConfig = (attach: WorkflowDocumentType): boolean => {
    const isRepairInvoice =
      attach.documentType!.code === AttachmentTypeCode.INVOICE_REPAIR.toString();
    const isRomania =
      this.props.appState.appUser?.organization?.country?.code === CountryCodeEnum.RO;
    return isRepairInvoice && this.state.organizationProvider != null && isRomania;
  };

  openPaymentConfigModal = () => {
    this.setState({ isPaymentConfigModalOpen: true });
  };

  savePaymentConfig = async () => {
    const { organizationProvider } = this.state;
    if (!organizationProvider) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'PAYMENT_CONFIG_MISSING',
          'Configuratia de plata nu a fost gasita.'
        ),
        { variant: 'warning' }
      );
      return;
    }

    this.setState({ isSavingPaymentConfig: true });
    try {
      const request: AddOrganizationProviderRequestDto = {
        id: organizationProvider.id,
        organizationId: organizationProvider.organizationId,
        partnerId: organizationProvider.partnerId,
        providerCategoryId: organizationProvider.providerCategoryId,
        paymentMethodId: organizationProvider.paymentMethodId,
        paymentDays: organizationProvider.paymentDays
      };
      await this.organizationService.AddOrganizationProvider(request);
      this.setState({ isPaymentConfigModalOpen: false });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'INVOICE_REGENRATE_INFO',
          'Factura ar trebui regenerata pentru a aplica noile setari.'
        ),
        { variant: 'warning' }
      );
    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } finally {
      this.setState({ isSavingPaymentConfig: false });
    }
  };

  handlePaymentMethodChange = (newValue: IReferential | null) => {
    const isCard = newValue?.code === PaymentMethodCodeEnum.CARD;
    this.setState({
      organizationProvider: {
        ...this.state.organizationProvider!,
        paymentMethodId: newValue?.id ?? 0,
        paymentMethod: newValue,
        paymentDays: isCard ? 0 : this.state.organizationProvider!.paymentDays
      }
    });
  };

  handlePaymentDaysChange = (value: string) => {
    this.setState({
      organizationProvider: {
        ...this.state.organizationProvider!,
        paymentDays: value === null || value === '' ? 0 : parseInt(value)
      }
    });
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({ target: { value: values.value } });
        }}
        allowNegative={false}
        decimalScale={0}
        isNumericString
      />
    );
  };


  handleBankTransferInvoiceActions = async () => {
    const isCarfix = this.props.caseSettingsState?.caseSettings?.workflow?.isCarfixIntegration;
    if (!isCarfix) return;

    const attachment = this.state.caseAttachments.length > 0 ? this.state.caseAttachments[0] : null;
    if (attachment === null) {
      return;
    }
    const attachmentType = this.state.attachmentTypeList.find(
      (item) => item.documentTypeId === attachment.attachmentTypeId
    );

    const isInvoiceRepair =
      attachmentType?.documentType?.code === AttachmentTypeCode.INVOICE_REPAIR.toString();

    const isFleet = this.state.lastCaseAppointment?.vehicleId ?? false;

    if (!isInvoiceRepair || !isFleet) return;

    await this.associateRepairMaintenanceCost();
    await this.handleInvoicePaymentConfirmation();
  };

  associateRepairMaintenanceCost = async () => {
    const { caseAttachments, currencies, lastCaseAppointment: appointment } = this.state;
    const attachment = caseAttachments[0];
    if (!attachment.invoiceId || !appointment) return;

    const invoice = await this.caseService.GetInvoiceById(attachment.invoiceId);
    if (!invoice) return;

    const currency = currencies.find((c) => c.code === invoice.currency) ?? null;
    if (!currency) return;

    const carInService = this.props.caseSettingsState.case!.carInService;
    const appointmentId = carInService ? appointment.parentId : appointment.id;
    if (!appointmentId) return;

    const request: AddRepairMaintenanceCostRequestDto = {
      appointmentId: appointmentId,
      paymentDate: invoice.invoiceDate,
      value: invoice.amount,
      currencyId: currency.id
    };

    await this.vehicleService.AddRepairMaintenanceCost(request);
  };

  handleInvoicePaymentConfirmation = async () => {
    const appointmentId = this.state.lastCaseAppointment?.id;
    if (!appointmentId) return;

    try {
      const request: InvoicePaymentConfirmationRequest = {
        appointmentId: appointmentId
      };
      const result = (await this.caseService.InvoicePaymentConfirm(
        request
      )) as InvoicePaymentConfirmationResponse;

      if (!result.success) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(result.message, result.message),
          {
            variant: 'error'
          }
        );
        return true;
      }
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
      return true;
    }
  };

  renderPaymentConfigModal = () => {
    const { isPaymentConfigModalOpen, paymentMethods, organizationProvider } = this.state;
    if (!organizationProvider) return null;

    return (
      isPaymentConfigModalOpen && (
        <Dialog
          onClose={() => this.setState({ isPaymentConfigModalOpen: false })}
          open={isPaymentConfigModalOpen}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="customized-dialog-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate(
                    'PAYMENT_CONFIG_MODAL_TITLE',
                    'Configurare plată'
                  )}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton
                  aria-label="close"
                  onClick={() => this.setState({ isPaymentConfigModalOpen: false })}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <ValidatorForm onSubmit={this.savePaymentConfig}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    id="paymentMethod"
                    className="m-2"
                    options={paymentMethods}
                    getOptionLabel={(m) => m.displayName ?? ''}
                    value={organizationProvider.paymentMethod}
                    onChange={(_e: any, newValue: IReferential | null) =>
                      this.handlePaymentMethodChange(newValue)
                    }
                    renderInput={(params) => (
                      <TextValidator
                        {...params}
                        name="paymentMethod"
                        value={organizationProvider.paymentMethod}
                        label={this.translatorService.Tranlate(
                          'PAYMENT_METHOD_ORGANIZATION_LABEL',
                          'Metoda plata'
                        )}
                        fullWidth
                        validators={['required']}
                        errorMessages={[
                          this.translatorService.Tranlate(
                            'VALIDATORS_REQUIRED',
                            'Campul este obligatoriu'
                          )
                        ]}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextValidator
                    fullWidth
                    name="paymentDays"
                    className="m-2"
                    id="paymentDays"
                    value={organizationProvider.paymentDays ?? ''}
                    onChange={(e: any) => this.handlePaymentDaysChange(e.target.value)}
                    label={this.translatorService.Tranlate(
                      'PAYMENT_DAYS_ORGANIZATION_LABEL',
                      'Termen plata (zile)'
                    )}
                    validators={['required', 'minNumber:0']}
                    errorMessages={[
                      this.translatorService.Tranlate(
                        'VALIDATORS_REQUIRED',
                        'Campul este obligatoriu'
                      ),
                      this.translatorService.Tranlate('VALIDATORS_MIN_VALUE', 'Valoare minima 0')
                    ]}
                    InputProps={{ inputComponent: this.NumberFormatCustom }}
                  />
                </Grid>
              </Grid>
              <div className="text-right">
                <Button className="m-2" variant="contained" color="secondary" type="submit">
                  {this.translatorService.Tranlate('SAVE', 'Salveaza')}
                </Button>
              </div>
            </ValidatorForm>
          </DialogContent>
        </Dialog>
      )
    );
  };

  openRepairServiceInvoiceModal = (attach: WorkflowDocumentType) => {
    const caseParameters = this.props.caseSettingsState.case?.caseParameters ?? [];
    const vatParameter = caseParameters.find(
      (parameter) => parameter.parameter!.code === ParametreCode.TVA
    );
    const vatValue = vatParameter ? parseFloat(vatParameter.value) : (null as any);
    const currencyParameter = caseParameters.find(
      (parameter) => parameter.parameter!.code === ParametreCode.CURRENCY
    );
    const currency = currencyParameter ? currencyParameter.value : '';

    this.setState({
      isRepairServiceInvoiceModalOpen: true,
      repairServiceInvoiceContext: {
        attachmentTypeId: attach.documentTypeId,
        attachmentTypeCode: attach.documentType?.code ?? '',
        vatValue: vatValue,
        currency: currency
      }
    });
  };

  closeRepairServiceInvoiceModal = () => {
    this.setState({ isRepairServiceInvoiceModalOpen: false });
  };

  handleRepairServiceInvoiceSaved = (response: AddInvoiceCaseAttachmentResponseDto) => {
    const newFiles = (response.caseAttachments ?? []) as CaseAttachment[];
    newFiles.forEach((file) => {
      file.invoice = response.invoice;
    });
    this.setState({ caseAttachments: [...this.state.caseAttachments, ...newFiles] });
    this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
      variant: 'success'
    });
  };

  renderRepairServiceInvoiceUploadButton = (attach: WorkflowDocumentType) => {
    return (
      <ButtonGroup className="w-100">
        <Button
          variant="contained"
          color="secondary"
          className="d-block w-100 text-center shadow-none"
          disabled={!this.state.hasRights || !this.canUpload(attach)}
          onClick={() => this.openRepairServiceInvoiceModal(attach)}
        >
          {this.translatorService.Tranlate('REPAIR_SERVICE_INVOICE_ADD_BTN', 'Adauga factura')}
        </Button>
      </ButtonGroup>
    );
  };

  renderAttachmentCardFooter = (attach: WorkflowDocumentType) => {
    const code = attach.documentType?.code;
    if (code === AttachmentTypeCode.REPAIR_SERVICE_INVOICE_TO_GTM.toString()) {
      return this.renderRepairServiceInvoiceUploadButton(attach);
    }
    if (
      code === AttachmentTypeCode.WORK_ORDER.toString() ||
      code === AttachmentTypeCode.HAND_OVER.toString() ||
      code === AttachmentTypeCode.INVOICE_REPAIR.toString()
    ) {
      return this.renderGenerateReportFooter(attach);
    }
    return this.renderUploadAndPhotoFooter(attach);
  };

  renderGenerateReportFooter = (attach: WorkflowDocumentType) => {
    const hasAttachment = this.state.caseAttachments.some(
      (item) => item.attachmentTypeId === attach.documentTypeId
    );
    return (
      <>
        {!hasAttachment ? (
          <ButtonGroup className="w-100 mb-1">
            <Button
              variant="contained"
              color="secondary"
              className="d-block w-100 text-center shadow-none"
              disabled={!this.state.hasRights || !this.canUpload(attach)}
              onClick={() =>
                this.generateReport(
                  attach,
                  this.state.appointment,
                  this.state.appointmentPaymentStatus,
                  this.state.organizationProvider
                )
              }
            >
              {attach.documentType!.code === AttachmentTypeCode.INVOICE_REPAIR.toString()
                ? this.translatorService.Tranlate(
                    'INVOICE_REPAIR_GENERATION_LABEL',
                    'Genereaza factura'
                  )
                : this.translatorService.Tranlate(
                    'IN_OUT_REPORT_GENERATION_LABEL',
                    'Genereaza raport'
                  )}
            </Button>
          </ButtonGroup>
        ) : null}
        {this.canEditPaymentConfig(attach) ? (
          <ButtonGroup className="w-100">
            <Button
              variant="outlined"
              color="primary"
              className="d-block w-100 text-center shadow-none"
              onClick={this.openPaymentConfigModal}
              disabled={!this.state.hasRights}
            >
              {this.translatorService.Tranlate(
                'PAYMENT_CONFIG_EDIT_BTN',
                'Modifica termen si metoda plata'
              )}
            </Button>
          </ButtonGroup>
        ) : null}
      </>
    );
  };

  renderUploadAndPhotoFooter = (attach: WorkflowDocumentType) => {
    return (
      <ButtonGroup className="w-100">
        <Button
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          variant="contained"
          color="secondary"
          className="d-block w-100 text-center shadow-none"
          disabled={!this.state.hasRights || !this.canUpload(attach)}
        >
          <input
            className="d-none"
            key={attach.fileInputKey}
            id={'contained-button-file' + attach.documentTypeId}
            disabled={!this.state.hasRights || !this.canUpload(attach)}
            onChange={(e) => {
              return this.handleUploadAttachment(e, attach);
            }}
            type="file"
            multiple={attach.isMultiple}
          />
          <label htmlFor={'contained-button-file' + attach.documentTypeId} className="w-100 mb-0">
            {this.translatorService.Tranlate('CASE_TAB_DOCUMENTS_FORM_UPLOAD', 'Upload')}
          </label>
        </Button>
        <Tooltip
          title={
            !this.state.hasRights
              ? ''
              : this.translatorService.Tranlate('CASE_DATA_TAKE_PHOTO_TITLE', 'Fotografiaza')
          }
        >
          <IconButton
            component="div"
            disabled={
              !this.state.hasRights ||
              !this.canUpload(attach) ||
              attach.documentType?.code ==
                AttachmentTypeCode.CERTIFICAT_CALITATE_SI_ORIGINE.toString()
            }
            style={{
              border: `2px solid ${MuiTheme.palette.primary.main}`,
              borderTopRightRadius: '8px',
              borderBottomRightRadius: '8px'
            }}
            onClick={(e: any) => this.setCameraDetails(attach)}
            aria-label="photo"
            color="primary"
            size="medium"
            className="p-0"
          >
            <PhotoCameraOutlinedIcon />
          </IconButton>
        </Tooltip>
      </ButtonGroup>
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.organizationService = (this.context as AppContext).organizationService;
    this.reportsService = (this.context as AppContext).reportsService;
    this.vehicleService = (this.context as AppContext).vehicleService;

    return (
      <Fragment>
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
        </div>
        {!this.state.isLoading ? (
          <div className="text-center mb-2">
            {this.state.showUploadMessage ? (
              <div className="d-flex flex-wrap m-1">
                <div className="p-1 d-flex justify-content-center">
                  <b>
                    {this.translatorService.Tranlate(
                      'PHOTO_LIMIT_MESSAGE',
                      'Conditiile pentru 1 upload sunt urmatoarele : Numar Total Poze ≤ 80 si Dimensiune Totala ≤ 500MB .'
                    )}
                  </b>
                </div>
              </div>
            ) : (
              ''
            )}
            <div className="d-flex flex-wrap m-1">{this.renderWorkflowAttachmentTypes()}</div>
            <div className="text-left mb-2">
              <Button
                className="m-2"
                variant="contained"
                color="secondary"
                onClick={this.downloadAll}
                disabled={this.state.executing}
                hidden={
                  this.state.caseAttachments.length === 0 ||
                  this.props.caseSettingsState.caseSettings!.workflow.isCarfixIntegration
                }
              >
                <GetAppIcon />{' '}
                {this.translatorService.Tranlate('CASE_DOCUMENTS_FORM_DOWNLOAD_ALL', 'Descarca')}
              </Button>
            </div>
            <br></br>
            {this.state.hideButton ? null : (
              <Button
                className="m-2"
                variant="contained"
                color="secondary"
                onClick={this.handleConfirmChanges}
                disabled={!this.state.hasRights || this.state.executing}
              >
                {this.props.caseSettingsState?.caseSettings!.workflow?.isCarfixIntegration &&
                this.hasIntegrationDocuments()
                  ? this.translatorService.Tranlate(
                      this.props.workflowForm.saveButtonKey || 'TAB_DOCUMENTS_SEND_TO_CLIENT',
                      'Trimite la client'
                    )
                  : this.translatorService.Tranlate(
                      this.props.workflowForm.saveButtonKey || 'SAVE',
                      'Salveaza'
                    )}
              </Button>
            )}
          </div>
        ) : null}

        <Dialog
          onClose={this.closeDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isDialogOpen}
          maxWidth="md"
          fullWidth
          fullScreen={false}
          classes={{ paper: 'dialogPaper' }}
          scroll="body"
        >
          <DialogTitle id="customized-dialog-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate('CASE_PREVIEW_DOC', 'Previzualizare document')}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container alignContent="center">
              <Grid item xs={12}>
                <Box height="65vh" className="text-center">
                  {this.renderPreviewAttachment()}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

        <Modal open={this.state.isOpen} onClose={this.handleCloseModal}>
          <Dialog open={this.state.dialogVisible} onClose={this.handleCloseConfirmationDialog}>
            <DialogContent>
              <DialogContentText style={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                {`${this.translatorService.Tranlate(
                  'DOCUMENT_DELETE_CONFIRMATION_MESSAGE',
                  'Sunteti sigur ca doriti sa stergeti documentul?'
                )} `}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => {
                  const selectedAttachment = this.state.selectedAttachment;
                  this.handleDeleteAttachment(
                    selectedAttachment.id,
                    selectedAttachment.fileName,
                    selectedAttachment.fileInputKey
                  );
                }}
              >
                {this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_YES', 'Da')}
              </Button>
              <Button onClick={() => this.handleCloseConfirmationDialog()}>
                {this.translatorService.Tranlate('VEHICLE_SEARCH_FORM_VEHICLE_NO', 'Nu')}
              </Button>
            </DialogActions>
          </Dialog>
        </Modal>

        <Dialog
          onClose={this.closeCameraDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.isCameraDialogOpen}
          fullWidth
          maxWidth={'lg'}
        >
          <DialogTitle id="customized-dialog-title">
            <Grid container>
              <Grid item xs={11}>
                <Typography variant="h4">
                  {this.translatorService.Tranlate('CASE_DATA_TAKE_PHOTO_TITLE', 'Fotografiaza')}
                </Typography>
              </Grid>
              <Grid className="text-right" item xs={1}>
                <IconButton aria-label="close" onClick={this.closeCameraDialog} size={'small'}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent dividers>
            <Camera
              onTakePhoto={(dataUri: any) => {
                this.handleTakePhoto(dataUri);
              }}
              onTakePhotoAnimationDone={(dataUri: any) => {
                this.closeCameraDialog();
              }}
              mirrored={true}
            />
          </DialogContent>
        </Dialog>
        {this.renderPaymentConfigModal()}
        {this.state.repairServiceInvoiceContext && (
          <RepairServiceInvoiceModal
            open={this.state.isRepairServiceInvoiceModalOpen}
            caseId={this.props.caseSettingsState.case?.id ?? 0}
            serviceOrganization={this.state.invoiceServiceOrganization}
            attachmentTypeId={this.state.repairServiceInvoiceContext.attachmentTypeId}
            attachmentTypeCode={this.state.repairServiceInvoiceContext.attachmentTypeCode}
            vatValue={this.state.repairServiceInvoiceContext.vatValue}
            currency={this.state.repairServiceInvoiceContext.currency}
            onClose={this.closeRepairServiceInvoiceModal}
            onSaved={this.handleRepairServiceInvoiceSaved}
          />
        )}
      </Fragment>
    );
  }
}

const mergeProps = (
  stateProps: any,
  dispatchProps: any,
  ownProps: ExternalCaseDetailsCaseTabDocumentsFormProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps
});
export default connect(
  (state: ApplicationState) => ({
    caseSettingsState: state.caseSettings,
    appState: state.app
  }),
  CaseSettingsActionCreators,
  mergeProps
)(withSnackbar(CaseDetailsCaseTabDocumentsForm as any));
